/**
* @param  {array or string} path - Path to the desired value
* @param  {obj} start - Optional object with which to start looking up properties on
* @return {*} - Whatever value is stored in the desired property or ''.
*/
module.exports = function (pathToProperty = [], start = global) {
    let currentLocation = start;

    pathToProperty = (typeof pathToProperty === 'string') ?
        pathToProperty.split('.') : pathToProperty;

    for (let currentProp of pathToProperty) {
        let propValue = currentLocation[currentProp];
        if ((propValue !== null) && typeof propValue !== 'undefined') {
            currentLocation = propValue;
        } else {
            return '';
        }
    }

    return currentLocation;
};
